import { render, staticRenderFns } from "./EndRiskAssessment.vue?vue&type=template&id=0abbb0c5&scoped=true"
import script from "./EndRiskAssessment.vue?vue&type=script&lang=ts"
export * from "./EndRiskAssessment.vue?vue&type=script&lang=ts"
import style0 from "./EndRiskAssessment.vue?vue&type=style&index=0&id=0abbb0c5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abbb0c5",
  null
  
)

export default component.exports